export default __webpack_public_path__ + "static/media/IMG-20240708-WA0025.ce2bc3d4.jpg";